import { render, staticRenderFns } from "./widget-nextCourses.vue?vue&type=template&id=232421dc"
import script from "./widget-nextCourses.vue?vue&type=script&lang=ts"
export * from "./widget-nextCourses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports